import Cookies from "js-cookie";
import {
  ADMIN_MODELS_GET_URL,
  ADMIN_MODEL_GET_URL,
  ADMIN_MODEL_CREATE_URL,
  ADMIN_MODEL_UPDATE_URL,
  ADMIN_MODEL_DELETE_URL,
} from "../apiurls/apiurls";

const getAuthToken = () => {
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getModels = async (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params && params.type) {
    searchParams.append("provider", params.type);
  }

  const url = searchParams.toString()
    ? `${ADMIN_MODELS_GET_URL}?${searchParams.toString()}`
    : ADMIN_MODELS_GET_URL;

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  if (data && Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getModelById = async (id) => {
  const params = new URLSearchParams();
  if (id) params.append("id", id);
  const response = await fetch(`${ADMIN_MODEL_GET_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const createModel = async (payload) => {
  const response = await fetch(ADMIN_MODEL_CREATE_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const updateModel = async (id, payload) => {
  const params = new URLSearchParams();
  if (id) params.append("id", id);
  const response = await fetch(
    `${ADMIN_MODEL_UPDATE_URL}?${params.toString()}`,
    {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    }
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const deleteModel = async (id) => {
  const params = new URLSearchParams();
  if (id) params.append("id", id);
  const response = await fetch(
    `${ADMIN_MODEL_DELETE_URL}?${params.toString()}`,
    {
      method: "DELETE",
      headers: getHeaders(),
    }
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
